module.exports = __webpack_public_path__ + "img/down-arrow.2f91c0ff.svg";